import util from '../util'

let controller = 'OperadorFrontEndConta'
export default Object.assign({}, util.GetCrud(controller, null), {
  ListarPorOperador: function(dto) {
    return util.Axios.GetAll(controller + '/PorOperador', dto)
  },
  GetPerfil: function() {
    return util.Axios.GetAll(controller + '/GetPerfil')
  },
  RemoverRelacaoOperadorConta: function(codigoOperadorFrontEnd, codigoConta) {
    let dto = {
      CodigoOperadorFrontEnd: codigoOperadorFrontEnd,
      CodigoConta: codigoConta
    }
    return util.Axios.DeleteAll(
      controller + '/RemoverRelacaoOperadorConta',
      dto
    )
  },
  ListarPorConta: function(dto) {
    return util.Axios.GetAll(controller + '/PorConta', dto)
  }
})
